import { useEffect, useState } from 'react';
import useChargingHistory from './useChargingHistory';
import { getCookie } from '../data/Cookies';
import { Period } from '../components/widgets/HistoryBarGraph';

export default function useStatistics() {
    let id = getCookie("id");

    const [statistics, setStatistics] = useState();

    const {history, getHistory} = useChargingHistory();

    function getStatistics() {
        getHistory();
        if (history === undefined) return;
        createStatistics();
    };

    useEffect(() => createStatistics(), [JSON.stringify(history)])

    function createStatistics() {
        if (history === undefined) return;

        const keys = Object.keys(Period);
        var newStatistics = {};

        keys.forEach((key) =>  {
            newStatistics[key] = createDataPoint(key);
        })

        setStatistics(newStatistics);
    }

    function createDataPoint(period) {
        const newEnergy = calculateSum("energy", history[period]);
        const newEmissions = calculateSum("emissions", history[period]);
        const newDuration = calculateSum("duration", history[period]);

        return {energy: newEnergy, emissions: newEmissions, duration: newDuration};
    }

    function calculateSum(key, list) {
        var sum = 0;
        list.forEach((entry) => {
            if (entry.length != 0) {
                if (Number.isFinite(entry[key])) sum += Number(entry[key]);
            }
        })
        return sum;
    }

    return {statistics: statistics, getStatistics: getStatistics};
};

